var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"siesta-instruction horizontal center",style:({maxWidth: _vm.maxWidth})},[_c('img',{staticClass:"icon",attrs:{"src":_vm.icon,"alt":""}}),_c('p',{staticClass:"text2 msg",domProps:{"innerHTML":_vm._s(_vm.msg)}})])}
var staticRenderFns = []

export { render, staticRenderFns }